// extracted by mini-css-extract-plugin
export default {"rowContainer":"full-screen-styles_rowContainer__t-eX7"};